/*
* Generate property description "property report" from template for an association
*/

import * as _ from 'lodash';
import * as React from 'react';
import { Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { push } from 'react-router-redux';
import { compose } from 'redux';
import { connectRequest } from 'redux-query';

import Branding from '../../branding/branding';
import * as AppComp from '../../common/app-component-base';
import { BootstrapColXl as Col } from '../../common/bootstrap/bootstrapcolxl';
import { Formatters } from '../../common/formatters';
import ApiEndpoints from '../../config/apiendpoints';
import * as LK from '../../config/apilookupkeys';
import * as ReduxQueries from '../../queries';

import { Render as ReportPageCover } from './pages/report-page-cover';
import { Render as ReportPageMap } from './pages/report-page-map';

import '../../branding/report-pdf.css';
import './association-property-report-pdf.css';

export interface IAssociationPropertyReportPdfProps extends AppComp.IAppComponentProps {
    association?: any;
    associationId?: any;
    navigateTo?: any;
}

export interface IAssociationPropertyReportPdfState extends AppComp.IAppComponentState {
    formChanges?: any;
    reportPageCount: number;
}

class AssociationPropertyReportPdf extends AppComp.AppComponent<IAssociationPropertyReportPdfProps, IAssociationPropertyReportPdfState> {
    public sectionPages: Array<any> = [];
    public originalFormDataCache = {};
    public pdfExportComponent: any = undefined;

    public constructor(props: any) {
        super(props, 'app.association-detail.');

        this.state = {
            formChanges: {},
            reportPageCount: 0,
        };
    }

    // TRANSFORMS

    // HELPERS
    public getFormData(associationIn: any, associationId: any) {
        // const assoc = _.merge(associationIn, this.state.formChanges);

        let result = {
            association: associationIn,
            associationId: associationId,
        };

        return _.merge(result, this.state.formChanges);
    }

    public getFormChangesCount() {
        return _.size(this.state.formChanges);
    }

    public getFormChangesResetRequired() {
        let resetFormData = false;
        // Props values
        const pa = Formatters.getInt(this.props, 'associationId');

        // Cached values
        const ca = Formatters.getInt(this.originalFormDataCache, 'associationId');

        // Determine if formdata state and cache needs reset due to changing associd or invid
        if (pa && ca) {
            resetFormData = (pa !== ca) ? true : false;
        }

        return resetFormData;
    }

    public getBrandingCssName(association: any) {
        const companyBrandKey = _.get(association, 'company.brandKey', Branding.appBrandKeys.complexSolutions);

        return companyBrandKey;
    }

    public render() {
        const { association, associationId, ...rest } = this.props;

        const isLoading = Number(Formatters.getInt(association, 'associationId')) !== Number(associationId);

        let page = (<div className="property-report-pdf-page-div-class-name" />);
        let brandingCssName = '';
        if (!isLoading) {
            const formData = this.getFormData(association, associationId);
            brandingCssName = this.getBrandingCssName(association);

            if (this.getFormChangesResetRequired() || !_.size(this.originalFormDataCache)) {
                this.originalFormDataCache = _.cloneDeep(formData);
            }

            // FOOTER DATA
            const reportData = {
                associationId: associationId,
                association: association,
                formData: formData,
            };

            /* console.log('pageData', {
                associationId: associationId,
                association: association,
                formData: formData,
                reportData: reportData,
                numChanges: this.getFormChangesCount(),
            }); */

            page = (
                <Row>
                    <Col xs={12}>
                        <ReportPageCover appText={(e) => this.appText(e)} appTextCommon={(e) => this.appTextCommon(e)} reportData={reportData} />
                        <ReportPageMap reportData={reportData} />
                    </Col>
                </Row>
            );
        }

        return (
            <div className={brandingCssName}>
                <AppComp.RenderPageWithLayout
                    branding={this.props.branding}
                    pageName=""
                    wrapperClassName={`pdf-association-property-report-page-layout-container`}
                    {...rest}
                >
                    <div className="center-block pdf-association-property-report-pages-container">
                        {page}
                    </div>
                </AppComp.RenderPageWithLayout>
            </div>
        );
    }
}

const getApiUrlLookups = () => ApiEndpoints.getLookupsByKeyUrl([
    LK.LookupKeys.Companies,
    LK.LookupKeys.Regions,
    LK.LookupKeys.StreetTypes,
    LK.LookupKeys.AssociationTypes,
    LK.LookupKeys.Clients,
    LK.LookupKeys.RoofTypes,
    LK.LookupKeys.SidingTypes,
    LK.LookupKeys.FencingTypes,
    LK.LookupKeys.InteriorHallTypes,
    LK.LookupKeys.IrrigationTypes,
    LK.LookupKeys.SecuredTypes,
    LK.LookupKeys.MechanicalTypes,
    LK.LookupKeys.ElevatorTypes,
    LK.LookupKeys.RecRoomTypes,
]);

const getApiUrl = (assocId) => ApiEndpoints.getAssociationDetailUrl(assocId);

const mapPropsToConfigs = (props) => {
    const assocId = props.match.params.associationId;

    return [
        ReduxQueries.Queries.getAssociationDetailRequest(
            getApiUrl(assocId),
            ReduxQueries.PropsAccessToken(props),
        ),

        ReduxQueries.Queries.getLookupsByKeyRequest(
            getApiUrlLookups(),
            ReduxQueries.PropsAccessToken(props)
        ),
    ];
};

const mapStateToProps = (state, props) => {
    const assocId = props.match.params.associationId;

    return ReduxQueries.MapQueryStateToPropsByUrl(getApiUrl(assocId), state, props, {
        association: state.entities.associationDetailAssociation,
        associationId: assocId,
    });
};

const mapDispatchToProps = {
    navigateTo: (path) => push(path)
};

const AssociationPropertyReportPdfContainer = compose<any>(
    connect(mapStateToProps, mapDispatchToProps),
    connectRequest(mapPropsToConfigs)
)(AssociationPropertyReportPdf);

export default withRouter(AssociationPropertyReportPdfContainer);



// WEBPACK FOOTER //
// ./src/association/property-report/pdf.tsx